import React from 'react'
import { useInventory } from 'hooks/inventory'
import VehicleForm from './VehicleForm'

interface ReadOnlyVehicleFormProps {
  vehicleId: string
  open: boolean
  onClose: () => void
  inventoryCollection?: 'master_inventory' | 'shield_inventory'
  canViewPurchasePrice?: boolean
  canViewProfit?: boolean
}

const ReadOnlyVehicleForm: React.FC<ReadOnlyVehicleFormProps> = ({
  vehicleId,
  open,
  onClose,
  inventoryCollection = 'master_inventory',
  canViewPurchasePrice = true,
  canViewProfit = true,
}) => {
  const { vehicles, isLoading } = useInventory(inventoryCollection)

  // Find the vehicle with the matching ID
  const vehicle = React.useMemo(() => {
    if (!vehicles || !vehicleId) return null
    return vehicles.find(v => v.id === vehicleId) || null
  }, [vehicles, vehicleId])

  // Don't render anything while loading or if vehicle not found
  if (isLoading || !vehicle) {
    return null
  }

  return (
    <VehicleForm
      open={open}
      vehicle={vehicle}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={() => {}}
      inventoryCollection={inventoryCollection}
      generateStockNumber={() => ''}
      isEdit={false}
      canViewPurchasePrice={canViewPurchasePrice}
      canViewProfit={canViewProfit}
      readOnly={true}
    />
  )
}

export default ReadOnlyVehicleForm
